module.exports = __webpack_public_path__ + "img/icons_1.89b96233.png";